import styled from 'styled-components';

import { IDashboard } from './Dashboard';

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100vh;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.gray900};
`;

export const Footer = styled.div`
  display: flex;
  height: 76px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.gray950};
  border-top: ${({ theme }) => theme.colors.gray800} 1px solid;
`;

export const BottomTab = styled.div<IDashboard.IFooter>`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  border-top: ${({ isSelected, theme }) =>
      isSelected ? `${theme.colors.primaryGreen500}` : 'transparent'}
    2px solid;

  label {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    color: ${({ isSelected, theme }) =>
      isSelected ? theme.colors.primaryGreen500 : theme.colors.gray0};
    text-shadow: 0 1px 2px rgba(12, 187, 114, 0.21);
    margin-top: 8px;
  }

  span {
    font-size: 20px;
    margin-top: 7px;

    :before {
      color: ${({ isSelected, theme }) =>
        isSelected ? theme.colors.primaryGreen500 : theme.colors.gray0};
    }
  }
`;
